import { Close, CheckCircle, Delete, Add, AutoAwesome} from '@mui/icons-material';
import { Modal, Button, IconButton } from '@mui/material';
import { Input as InputArea } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import TextReader from 'components/Reader';
import Loading from 'components/Loading';
import { EnterOutlined } from '@ant-design/icons';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import SpanishVocabTab from 'modules/word_bank/type/spanishVocabTab';
import React, { useEffect } from 'react';
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import {
  handleGenerateCognateWordBankNonNative,
  handleGenerateCognateWordBank,
} from 'store/word_bank/thunks';
import { useState } from 'react';
import { useRef } from 'react';
import * as Sentry from '@sentry/react';
import { filter, get } from 'lodash';
import { useVocabulary } from 'store/vocabulary/selectors';
import { usePhrases } from 'store/Phrases/selectors';
import {
  handleCreateVocabulary,
  handleCreateVocabularyAI,
  handleDeleteVocabulary,
  handleGenerateVocabularyWithMode,
  handleListVocabulary,
} from 'store/vocabulary/thunks';
import { handleListPhrases, handleCreatePhrases, handleDeletePhrases, handleGeneratePhrasesWithAI, handleGeneratePhrasesWithMode } from 'store/Phrases/thunks';
import { useCurrentClass } from 'store/classes/selectors';
import { DeleteModal } from 'components/Dialog';
import Cogantes from 'components/ebook/cogantes';
import { useCognets } from 'store/cogantes/selectors';
import CognateAiLoader from 'components/ebook/cogantes/cognateAiModal';
import { handleStreamResponseForCognates } from 'utils/methods/CognatesStreamHandler';
import { createVocabularySuccessCogantes } from 'store/cogantes/actions';
import { useConfirm } from 'components/UI/confirmProvider';
import { useLocation } from 'react-router-dom';
import BadgeButton from 'components/AdminBooks/BadgeButton';
  

const ModalContents = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 10px;
  width: ${(p) => (p.is_non_spanish ? '100% !important' : '93% !important')};
  max-width: ${(p) => (p.is_non_spanish ? '95vw !important' : '')};
`;

const MENU = [
  { id: 'page_vocab', value: 'Page Vocabulary' },
  { id: 'page_phrases', value: 'Page Phrases' },
  { id: 'cognates', value: 'Cognates' },
  { id: 'congantes_with_ai', value: 'Cognates with AI' },
];

const VocabCognates = ({ pageId, bookId, is_non_spanish = false, from = {} }) => {
  const currentUser = useCurrentUser();
  const showAlert = useAlert();
  const [newItem, setNewItem] = useState({ isEditable: true });
  const currentClass = useCurrentClass();
  const [deleteVocab, setDeleteVocab] = useState({});
  const dispatch = useDispatch();
  const [vocabularyData, setVocabularyData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [vocabularyAI, setVocabularyAI] = useState({});
  const [addVocabData, setAddVocabData] = useState({});
  const [deleteVoc, setDeleteVoc] = useState(false);
  const [dataTab, setDataTab] = useState(MENU[0].id);
  const [loading, setLoading] = useState(false);
  const [showWordLoader, setShowWordLoader] = useState(false);
  const [showWordEnglishLoader, setShowEnglishWordLoader] = useState(false);
  const [generationLoader, setGenerationLoader] = useState(false);
  const vocabdomRef = useRef();
  const [selected_mode, setSelectedMode] = useState('english_to_spanish');
  const [openVocabulary, setOpenVocabulary] = useState(false);
  const bookVocabulary = useVocabulary();
  const bookPhrases = usePhrases();
  const bookCognets = useCognets();
  const [aiModal, setAiModal] = useState(false);
  const [phrasesData, setPhrasesData] = useState([]);
  const [addPhraseData, setAddPhraseData] = useState({});
  const [phraseAI, setPhraseAI] = useState({});
  const [showPhraseAdd, setShowPhraseAdd] = useState(false);
  const [showPhraseLoader, setShowPhraseLoader] = useState(false);
  const confirm = useConfirm();
  const location = useLocation();

  useEffect(() => {
    // const data = dispatch(handleListVocabulary({ pageId: pageId, bookId: bookId }));
    // const filteredVocab = filter(
    //   bookVocabulary,
    //   (obj) => obj.chapter == bookId && obj.page == pageId,
    // );
    // setVocabularyData(filteredVocab);
  }, [bookVocabulary, pageId, bookId]);

  useEffect(() => {
    dispatch(handleListPhrases(pageId, bookId, currentUser));
  }, [pageId, bookId, currentUser]);

  useEffect(() => {
    const filteredPhrases = filter(
      bookPhrases,
      (obj) => obj.chapter == bookId && obj.page == pageId,
    );
    setPhrasesData(filteredPhrases);
  }, [bookPhrases, pageId, bookId]);

  const handleCloseModal = async () => {
    const filteredData = vocabularyData.filter((item) => !item.isEditable);
    const filteredPhrasesData = phrasesData.filter((item) => !item.isEditable);
    setVocabularyData(filteredData);
    setPhrasesData(filteredPhrasesData);
    setDataTab(MENU[0].id);
    setOpenVocabulary(false);
  };

  const addNewItem = () => {
    const isEditableItemExists = vocabularyData.some((item) => item.isEditable);
    if (!isEditableItemExists) {
      const updatedData = [...vocabularyData, newItem];
      setVocabularyData(updatedData);
    }
  };

  const addNewPhraseItem = () => {
    const isEditableItemExists = phrasesData.some((item) => item.isEditable);
    if (!isEditableItemExists) {
      setAddPhraseData({});
      setPhraseAI({});
      const updatedData = [...phrasesData, newItem];
      setPhrasesData(updatedData);
    }
  };

  const countWords = (text) => {
    if (!text || text.trim() === '') return 0;
    return text.trim().split(/\s+/).length;
  };

  const validateWordLimit = (text, maxWords = 10) => {
    const wordCount = countWords(text);
    return wordCount <= maxWords;
  };

  const handleAddPhraseData = (key, value) => {
    if (key === 'phrase') {
      if (!validateWordLimit(value)) {
        const words = value.trim().split(/\s+/);
        const limitedValue = words.slice(0, 10).join(' ');
        setAddPhraseData({ ...addPhraseData, [key]: limitedValue });
        showAlert(`You can only enter up to 10 words in the phrase field`, 'error');
        return;
      }
      setAddPhraseData({ ...addPhraseData, [key]: value });
    } else {
      setPhraseAI({ ...phraseAI, [key]: value });
    }
  };

  const editDataPropertyStd = (targetId, newValue, propertyName) => {
    const itemToEdit = vocabularyData.find((item) => item.id === targetId);
    const updatedData = vocabularyData.map((item) =>
      item.id === targetId
        ? {
            ...item,
            data: {
              ...item.data,
              [propertyName]: newValue,
            },
          }
        : item,
    );
    if (itemToEdit) {
      if(typeof itemToEdit.data === 'undefined'){
        itemToEdit.data = {};
      }
      itemToEdit.data[propertyName] = newValue;
    }
    setVocabularyData(updatedData);
  };

  const editPhraseDataProperty = (targetId, newValue, propertyName) => {
    if (propertyName === 'phrase' && !validateWordLimit(newValue)) {
      const words = newValue.trim().split(/\s+/);
      const limitedValue = words.slice(0, 10).join(' ');
      const itemToEdit = phrasesData.find((item) => item.id === targetId);
      const updatedData = phrasesData.map((item) =>
        item.id === targetId
          ? {
              ...item,
              data: {
                ...item.data,
                [propertyName]: limitedValue,
              },
            }
          : item,
      );
      if (itemToEdit) {
        if(typeof itemToEdit.data === 'undefined'){
          itemToEdit.data = {};
        }
        itemToEdit.data[propertyName] = limitedValue;
      }
      setPhrasesData(updatedData);
      showAlert(`You can only enter up to 10 words in the phrase field`, 'error');
      return;
    }
    const itemToEdit = phrasesData.find((item) => item.id === targetId);
    const updatedData = phrasesData.map((item) =>
      item.id === targetId
        ? {
            ...item,
            data: {
              ...item.data,
              [propertyName]: newValue,
            },
          }
        : item,
    );
    if (itemToEdit) {
      if(typeof itemToEdit.data === 'undefined'){
        itemToEdit.data = {};
      }
      itemToEdit.data[propertyName] = newValue;
    }
    setPhrasesData(updatedData);
  };

  const handleAddVocData = (key, value) => {
    if (key === 'word') {
      const v = { ...addVocabData };
      v[key] = value;
      setAddVocabData(v);
    } else {
      const v = { ...vocabularyAI };
      v[key] = value;
      setVocabularyAI(v);
    }
  };

  const callVocAI = async () => {
    if (addVocabData?.word) {
      setShowWordLoader(true);
      let result = null;
      if (is_non_spanish) {
        result = await dispatch(
          handleGenerateVocabularyWithMode({
            topic: addVocabData?.word,
            book_id: bookId,
            page: pageId,
            chapter: bookId,
            created_by: currentUser?.role,
            user_id: get(currentUser, 'id', ''),
            class_id: get(currentClass, 'id', ''),
            mode: selected_mode,
          }),
        );
      } else {
        result = await dispatch(
          handleCreateVocabularyAI({
            topic: addVocabData?.word,
            book_id: bookId,
            page: pageId,
            chapter: bookId,
            created_by: currentUser?.role,
            user_id: get(currentUser, 'id', ''),
            class_id: get(currentClass, 'id', ''),
          }),
        );
      }

      if (result) {
        showAlert('Created Successfully', 'success');
      } else {
        showAlert('No Result Found', 'error');
      }
      setShowWordLoader(false);
    }
  };

  const callVocWithNonSpanishModes = async () => {
    if (addVocabData?.word) {
      setShowWordLoader(true);
      const result = await dispatch(
        handleGenerateCognateWordBankNonNative({
          topic: addVocabData?.word,
          user_id: currentUser?.id,
          type: dataTab,
          mode: selected_mode,
        }),
      );

      if (result && !result.error) {
        showAlert('Created Successfully', 'success');
      } else {
        showAlert('No Result found', 'error');
      }
      setAddVocabData({});
      setShowWordLoader(false);
    }
  };

  const onDeleteVocab = async () => {
    await dispatch(handleDeleteVocabulary(deleteVocab?.id));
    setDeleteModal(false);
    setDeleteVoc(false);
  };

  const onDeletePhrase = async () => {
    await dispatch(handleDeletePhrases(deleteVocab?.id));
    setDeleteModal(false);
    setDeleteVoc(false);
  };

  const handleUpdateData = async (data) => {
    let datas = vocabularyData.find((item) => item.id === data?.id);
    const response = await dispatch(handleCreateVocabulary(datas));
    if (response?.id) {
      showAlert('Updated Successfully', 'success');
    } else {
      showAlert('Updated Failed', 'error');
    }
  };

  const handleUpdatePhraseData = async (data) => {
    let datas = phrasesData.find((item) => item.id === data?.id);
    const response = await dispatch(handleCreatePhrases(datas));
    if (response?.id) {
      showAlert('Updated Successfully', 'success');
    } else {
      showAlert('Updated Failed', 'error');
    }
  };

  const addPhrase = (phraseData) => {
    const dataToAdd = phraseData ? phraseData : phraseAI;
    const dataPhrase = {
      book_id: bookId,
      page: pageId,
      chapter: bookId,
      created_by: currentUser?.role,
      user_id: get(currentUser, 'id', ''),
      class_id: get(currentClass, 'id', ''),
      data: {
          phrase: addPhraseData.phrase,
          english_translation: addPhraseData.english_translation || '',
          sentence: addPhraseData.sentence || '',
          sentence_english: addPhraseData.sentence_english || '',
        ...dataToAdd
      },
    };
    dispatch(handleCreatePhrases(dataPhrase));
    showAlert('Created Successfully', 'success');
    if (dataToAdd) {
      setAddPhraseData({});
      setPhraseAI({});
      setShowPhraseAdd(false);
    }
  };

  const callPhraseAI = async () => {
    if (addPhraseData?.phrase) {
      setShowPhraseLoader(true);
      let result = null;
         result = await dispatch(
          handleGeneratePhrasesWithAI({
            topic: addPhraseData?.phrase,
            book_id: bookId,
            page: pageId,
            chapter: bookId,
            created_by: currentUser?.role,
            user_id: get(currentUser, "id", ""),
            class_id: get(currentClass, "id", ""),
          })
        );

      if (result) {
        setShowPhraseAdd(false);
        showAlert('Created Successfully', 'success');
      } else {
        showAlert('No Result Found', 'error');
      }
      setShowPhraseLoader(false);
    }
  };

  // Filter data based on the current tab
  const filteredVocabularyData = vocabularyData.filter(
    (item) => item.type === dataTab || item.isEditable,
  );

  const callCognetsVocAI = async (type = '') => {
    try {
      if (addVocabData?.word) {
        if (type === 'english') {
          setShowEnglishWordLoader(true);
        } else {
          setShowWordLoader(true);
        }

        const result = await dispatch(
          handleGenerateCognateWordBank({
            topic: addVocabData?.word,
            type: dataTab,
            user_id: currentUser?.id,
            language: type,
          }),
        );

        if (result && !result.error) {
          showAlert('Created Successfully', 'success');

          if (vocabdomRef) {
            vocabdomRef.current.scrollTo(0, vocabdomRef.current.scrollHeight);
          }
        } else {
          showAlert('Updated Successfully', 'success');
        }
        setAddVocabData({});
      }
    } catch (error) {
      Sentry.captureException(`638 Error in callCognetsVocAI: ${error}`);
      console.log(error);
    } finally {
      setShowEnglishWordLoader(false);
      setShowWordLoader(false);
    }
  };

  const checkGenerateFromAi = async () => {
    try {
      const filterVocab = bookCognets?.filter((obj) => obj.page == pageId);
      const filterByAdmin = filterVocab?.filter((data) => data?.created_by === 'owe_admin') || [];
      const filterByTeacher = filterVocab?.filter((data) => data?.created_by === 'teacher') || [];
      const data = [...filterByAdmin, ...filterByTeacher];

      const isShowAiAlert = data.some((data) => data.is_ai === true);

      const dataAi = {
        bookId,
        page: pageId,
        chapter: bookId,
        created_by: currentUser?.role,
        user_id: get(currentUser, 'id', ''),
        class_id: get(currentClass, 'id', ''),
        resource: location.pathname.includes('/edit-resource') ? true : false,
      };

      handleCloseModal();

      const proceedWithAI = async () => {
        setAiModal(true);
        let generatedCount = 0;
        setGenerationLoader(false);
        await handleStreamResponseForCognates({
          path: 'ai/generate-cognates-stream',
          body: dataAi,
          onFirstResponse: () => {
            setAiModal(false);
            setOpenVocabulary(true);
            setDataTab(MENU[1].id);
            setGenerationLoader(true);
          },
          onCognate: (cog) => {
            if (cog && cog.id) {
              dispatch(createVocabularySuccessCogantes(cog))
            }
            generatedCount++;
          },
          onDuplicate: (dup) => {
          },
          onDone: () => {
             if(generatedCount === 0){
              showAlert("This page doesn't contain any data.", 'error');
            }
            setGenerationLoader(false);
          },
          onError: (err) => {
            setGenerationLoader(false);
            setAiModal(false);
            showAlert("Something went wrong, please try again later.", 'error');
            console.error('Error in AI stream:', err);
          }
        })
      };

      if (isShowAiAlert) {
        confirm({
          title: 'Confirm',
          content: `You've already generated contents on this page. Are you sure you want to regenerate them?`,
          okText: 'Continue',
          okButtonProps: {
            className: 'force-blue-button',
            style: {
              backgroundColor: '#012B70 !important',
              borderColor: '#012B70 !important',
            },
          },
          onOk: async (close) => {
            close();
            await proceedWithAI();
          },
          onCancel: () => {
            setOpenVocabulary(true);
            setDataTab(MENU[1].id);
          },
        });
      } else {
        await proceedWithAI();
      }
    } catch (error) {
      Sentry.captureException(`293 Error in checkGenerateFromAi: ${error}`);
      console.log(error);
    }
  };

  return (
    <>
      <CognateAiLoader aiModal={aiModal} />
      <DeleteModal
        deleteToggle={deleteModal}
        loading={deleteVoc}
        onDelete={() => {
          if (dataTab === 'page_phrases') {
            onDeletePhrase();
          } else {
            onDeleteVocab();
          }
          setDeleteVoc(true);
        }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove this ${
          deleteVocab?.data && (deleteVocab?.data?.word || deleteVocab?.data?.phrase) 
            ? `"${deleteVocab.data.word || deleteVocab.data.phrase}"` 
            : ''
        } ${dataTab === 'page_phrases' ? 'phrase' : 'vocabulary'}?`}
      />

      <BadgeButton
        startIcon={<AutoAwesome />}
        showBadge={vocabularyData?.length > 0}
        backgroundColor="#667eea"
        onClick={() => setOpenVocabulary(true)}
      >
        Vocabulary
      </BadgeButton>

      <Modal
        className="vocabulModal"
        open={openVocabulary}
        onClose={handleCloseModal}
        style={{ height: '100%', width: '100%', backgroundColor: 'transparent' }}
      >
        <ModalContents is_non_spanish={is_non_spanish} className="vocabulContent">
          <div className="VocabularyTab FirstVocabularyTab flex items-stretch gap-5px flex-wrap mr-26px">
            <div className="flex items-center gap-10px mb-10px justify-start w-full">
              <div className='flex items-center gap-10px'>
                {MENU?.map((ele) => {
                  if (dataTab === 'page_vocab' && ele?.id === 'congantes_with_ai') {
                    return null;
                  }
                  return (
                    <Button
                      key={ele.id}
                      className={
                        dataTab === ele?.id
                          ? 'selected selected-background-color text-white'
                          : 'unselected-color'
                      }
                      onClick={() => {
                        if (ele?.id === 'congantes_with_ai') {
                          checkGenerateFromAi();
                          return;
                        }
                        const filteredData = vocabularyData?.filter((item) => !item.isEditable);
                        setVocabularyData(filteredData);
                        setDataTab(ele?.id);
                      }}
                    >
                      {ele?.value}
                    </Button>
                  );
                })}
              </div>

              <Close color="secondary" onClick={handleCloseModal} className="vocabulClose" />
            </div>
          </div>
          <div
            className="vocabulTableUpr vocab-table-upar vocInMobile vocabStrokeWidth"
            style={{ maxHeight: 550, overflowY: 'scroll' }}
          >
            {dataTab === 'page_vocab' && (
              <SpanishVocabTab
                vocabularyData={vocabularyData}
                showWordLoader={showWordLoader}
                callVocAI={callVocAI}
                handleAddVocData={handleAddVocData}
                editDataPropertyStd={editDataPropertyStd}
                handleUpdateData={handleUpdateData}
                addNewItem={addNewItem}
                setDeleteModal={setDeleteModal}
                setDeleteVocab={setDeleteVocab}
                currentUser={currentUser}
                from={from}
              />
            )}

            {dataTab === 'page_phrases' && (
              <table border="1" className='vocabulTable'>
                <tr className='vocabulHeadTh'>
                  <th>Phrase</th>
                  <th>Translation</th>
                  <th>Sentence in Spanish</th>
                  <th>Sentence in English</th>
                  <th>Actions</th>
                </tr>
                {phrasesData.map((value, index) => {
                  const data = get(value, 'data', '');
                  const mode = data?.mode || "";
                  if (value?.created_by == 'student') return;
          
                  return (
                    <tr className='vocabulHeadTr vocIcons' key={index}>
                      <td style={{ minWidth: 150, maxWidth: 250 }}>
                        {value?.isEditable ? (
                          <div style={{ position: 'relative' }}>
                            <InputArea
                              value={addPhraseData.phrase || ''}
                              onPressEnter={() => {
                                if (!showPhraseLoader) {
                                  callPhraseAI();
                                }
                              }}
                              onChange={(d) => { handleAddPhraseData('phrase', d.target.value.trimStart()) }}
                              placeholder='phrase'
                              autoSize
                              autoFocus
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                            />
                            <div style={{ position: 'absolute', top: 6, right: 4 }}>
                              {showPhraseLoader ? <Loading size={17} /> : <EnterOutlined disabled={showPhraseLoader} onClick={() => {
                                if (!showPhraseLoader) {
                                  callPhraseAI();
                                }
                              }} style={{ fontSize: '25px' }} />}
                            </div>
                          </div>
                        ) : (
                          <>
                            <TextReader text={get(data, 'phrase', '')} language={mode === 'english_to_spanish' ? "en-US" : mode === 'spanish_to_english' ? "es-ES" : "es-ES"} style={{ float: "right" }} />
                            <InputArea
                              disabled={value?.created_by === 'owe_admin'}
                              value={get(data, 'phrase', '') + (value?.created_by === 'owe_admin' ? ' (Admin)' : '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), 'phrase')}
                              placeholder='phrase'
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                            />
                          </>
                        )}
                      </td>
                      <td>
                        {value?.isEditable ? (
                          <TextArea
                            value={get(data, 'english_translation', '')}
                            onChange={(d) => { handleAddPhraseData('english_translation', d.target.value.trimStart()) }}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        ) : (
                          <>
                            <TextReader text={get(data, 'english_translation', '')} language={mode === 'english_to_spanish' ? "es-ES" : mode === 'spanish_to_english' ? "en-US" : "en-US"} style={{ float: "right" }} />                        
                            <TextArea
                              onBlur={() => {
                                handleUpdatePhraseData(value)
                              }}
                              value={get(data, 'english_translation', '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), 'english_translation')}
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                            />
                          </>
                        )}
                      </td>
                      <td>
                        {value?.isEditable ? (
                          <TextArea
                            value={get(data, 'sentence', '')}
                            onChange={(d) => { handleAddPhraseData('sentence', d.target.value.trimStart()) }}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        ) : (
                          <>
                            <TextReader text={get(data, is_non_spanish ? 'sentence_in_spanish' : 'sentence', '')} language={mode === 'english_to_spanish' ? "es-ES" : mode === 'spanish_to_english' ? "es-ES" : "es-ES"} style={{ float: "right" }} />
                            <TextArea
                              onBlur={() => {
                                handleUpdatePhraseData(value)
                              }}
                              value={get(data, is_non_spanish ? 'sentence_in_spanish' : 'sentence', '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), is_non_spanish ? 'sentence_in_spanish' : 'sentence')}
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                            />
                          </>
                        )}
                      </td>
                      <td>
                        {value?.isEditable ? (
                          <TextArea
                            value={get(data, is_non_spanish ? 'sentence_in_english' : 'sentence_english', '')}
                            onChange={(d) => { handleAddPhraseData(is_non_spanish ? 'sentence_in_english' : 'sentence_english', d.target.value.trimStart()) }}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        ) : (
                          <>
                            <TextReader text={get(data, is_non_spanish ? 'sentence_in_english' : 'sentence_english', '')} language={"en-US"} style={{ float: "right" }} />
                            <TextArea
                              onBlur={() => {
                                handleUpdatePhraseData(value)
                              }}
                              value={get(data, is_non_spanish ? 'sentence_in_english' : 'sentence_english', '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), is_non_spanish ? 'sentence_in_english' : 'sentence_english')}
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                            />
                          </>
                        )}
                      </td>
                      {value?.created_by !== 'student' ? (
                        <td style={{ textAlign: 'center' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Delete style={{ fontSize: '20px' }} onClick={() => {
                              setDeleteModal(true);
                              setDeleteVocab(value);
                            }} />
                          </div>
                        </td>
                      ) : (
                        <td style={{ textAlign: 'center' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <span style={{ fontSize: '14px', color: 'white', fontWeight: '500' }}>Student</span>
                          </div>
                        </td>
                      )}
                    </tr>
                  )
                })}
                {showPhraseAdd && (
                  <tr className='vocabulHeadTr vocIcons'>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.phrase === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, phrase: e.target.value })
                        }}
                        value={get(phraseAI, "phrase", "")}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.english_translation === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, english_translation: e.target.value })
                        }}
                        value={phraseAI?.english_translation}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.sentence === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, sentence: e.target.value })
                        }}
                        value={phraseAI?.sentence}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.sentence_english === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, sentence_english: e.target.value })
                        }}
                        value={phraseAI?.sentence_english}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      </div>
                    </td>
                  </tr>
                )}
                <tr className='vocabulHeadTr'>
                      <td>
                        <IconButton>
                          <Add style={{ fontSize: '18px' }} onClick={() => {
                            addNewPhraseItem()
                          }} />
                        </IconButton>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                </tr>
              </table>
            )}

            {dataTab === 'cognates' && (
              <Cogantes
                tabSelector={dataTab}
                bookId={bookId}
                pageId={pageId}
                non_native={is_non_spanish}
                from={from}
              />
            )}
          </div>
        </ModalContents>
      </Modal>
    </>
  );
};

export default VocabCognates;
